module.exports = __webpack_public_path__ + "static/media/yz_front.9f9467a7.webp";